import { morph } from '@theme/morph';

class ProductRecommendations extends HTMLElement {
  connectedCallback() {
    if (this.querySelector('.product-recommendations__inner') || !this.dataset.url) return;
    this.observer = new IntersectionObserver(this.load, { rootMargin: '0px 0px 300px' });
    this.observer.observe(this);
  }

  disconnectedCallback() {
    this.observer?.disconnect();
    this.controller?.abort();
  }

  updateProduct(productId) {
    if (!productId || productId === this.dataset.productId) return;
    this.controller?.abort();
    this.observer?.disconnect();
    const url = new URL(this.dataset.url, window.location.origin);
    url.searchParams.set('product_id', productId);
    this.dataset.productId = productId;
    this.dataset.url = url.toString();
    morph(this, this.cloneNode(false));
    this.hidden = false;
    this.observer = new IntersectionObserver(this.load, { rootMargin: '0px 0px 300px' });
    this.observer.observe(this);
  }

  load = async (entries) => {
    if (!entries.some((entry) => entry.isIntersecting)) return;
    this.observer.disconnect();
    this.controller = new AbortController();
    try {
      const response = await fetch(this.dataset.url, { headers: { Accept: 'text/html' }, signal: this.controller.signal });
      if (!response.ok) return;
      const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
      const next = parsed.querySelector('product-recommendations');
      if (next?.querySelector('.product-recommendations__inner')) {
        morph(this, next);
      } else {
        this.hidden = true;
      }
    } catch (error) {
      if (error.name !== 'AbortError') this.hidden = true;
    }
  };
}

if (!customElements.get('product-recommendations')) customElements.define('product-recommendations', ProductRecommendations);
